import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChildren
} from '@angular/core';
import {HintManagerService} from "../../../services/hintManager/hint-manager.service";
import {Item} from "../../../models/Item";
import {WhiteTooltipDirective} from "../../../directives/whiteTooltip/white-tooltip.directive";
import {RotateObjectService} from "../../../services/rotateService/rotate-object.service";
declare var Yiit;

@Component({
  selector: 'app-rotation-option',
  templateUrl: './rotation-option.component.html',
  styleUrls: ['./rotation-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RotationOptionComponent implements OnInit, OnDestroy {

  @Input() item:Item;
  @ViewChildren(WhiteTooltipDirective) tooltips;

  public rotation;
  public Yiit = Yiit;
  constructor(private hintManager: HintManagerService, protected cd: ChangeDetectorRef, protected rotateService: RotateObjectService) {
    // this.item.getSubject('rotation').subscribe((val)=>{
    //
    // })
  }

  ngOnDestroy(): void {
    this.tooltips.forEach((_item:WhiteTooltipDirective)=>{
      _item.hide();
    });
  }

  ngOnInit() {
    this.rotation = this.item.config.getRotation();
  }

  changeRotation(degrees, e?){
    if (e){
      e.preventDefault();
      e.stopPropagation();
    }
    this.item.getSubject(Item.SUBJECT_ROTATE_BY).next({newVal: degrees, oldVal:this.item.config.getRotation()});
    this.cd.detectChanges();
    // this.item.onRotationChange(degrees);
  }

  changeRotationByClick(event, isLeft?){
    if (event.shiftKey){
      this.changeRotation((isLeft) ? -1 : 1, event);
    }
    else{
      this.changeRotation((isLeft) ? -5 : 5, event);
    }
    this.hintManager.hintText = "Click for 5° rotation <br/> Shift+Click for 1° rotation";
    this.cd.detectChanges();
  }

}
